module.exports = __webpack_public_path__ + "assets/img/img222.97d78411.png";